import { useRef } from "react";
import { ReactSortable } from "react-sortablejs";
import { STORAGE_URL } from "../../../constants";

export default function PhotoUploader({ photos, setPhotos }) {
    const inputRef = useRef();

    const handleAddPhoto = (e) => {
        const files = Array.from(e.target.files);
        const newFiles = files.map((file) => ({
            file,
            preview: URL.createObjectURL(file),
        }));
        setPhotos([...photos, ...newFiles]);
    };

    const handleDelete = (index) => {
        const updated = [...photos];
        updated.splice(index, 1);
        setPhotos(updated);
    };

    // const handleSort = (order) => {
    //     const sorted = order.map((id) => photos[parseInt(id)]);
    //     setPhotos(sorted);
    // };

    return (
        <div className="col-sm-12 col-xs-12">
            <label className="form-label mb-8 h6">Foto Produk (Drag untuk urutkan):</label>
            <input
                type="file"
                multiple
                accept="image/*"
                onChange={handleAddPhoto}
                ref={inputRef}
                className="form-control py-11"
            />

            <ReactSortable
                list={photos}
                setList={setPhotos}
                animation={200}
            >
                {photos.map((photo, i) => (
                    <div
                        key={i}
                        data-id={i}
                        style={{
                            display: "inline-block",
                            margin: "10px",
                            position: "relative",
                        }}
                    >
                        <img
                            src={photo.preview || `${STORAGE_URL}${photo.file_path}`}
                            alt="preview"
                            width="100"
                            height="100"
                            style={{ objectFit: "cover", borderRadius: "4px" }}
                        />
                        <button
                            type="button"
                            onClick={() => handleDelete(i)}
                            style={{
                                position: "absolute",
                                top: 0,
                                right: 0,
                                background: "red",
                                color: "white",
                                border: "none",
                                borderRadius: "50%",
                                width: "20px",
                                height: "20px",
                                fontSize: "12px",
                            }}
                        >
                            ×
                        </button>
                    </div>
                ))}
            </ReactSortable>
        </div>
    );
}
